import * as React from "react";
import styled from "styled-components";
import { Unstable_NumberInput as BaseNumberInput } from "@mui/base/Unstable_NumberInput";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import {
  Black,
  Focused,
  Grey,
  GreyStroke,
  Primary,
  Secondary,
} from "src/styles/color";
import device from "src/styles/device";

const NumberInput = React.forwardRef(function CustomNumberInput(props, ref) {
  return (
    <BaseNumberInput
      slots={{
        root: StyledInputRoot,
        input: StyledInput,
        incrementButton: StyledButton,
        decrementButton: StyledButton,
      }}
      slotProps={{
        incrementButton: {
          children: <AddIcon fontSize="small" />,
          className: "increment",
        },
        decrementButton: {
          children: <RemoveIcon fontSize="small" />,
        },
      }}
      {...props}
      ref={ref}
    />
  );
});

const StyledInputRoot = styled.div`
  font-weight: 400;
  color: ${Black};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

const StyledInput = styled.input`
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.375;
  color: ${Black};
  background: #fff;
  border: 1px solid ${GreyStroke};
  border-radius: 8px;
  margin: 0 8px;
  padding: 6px 12px;
  outline: 0;
  min-width: 0;
  width: 80px;
  text-align: center;

  &:hover {
    border-color: ${Secondary};
  }

  &:focus {
    border-color: ${Grey};
  }

  &:focus-visible {
    outline: 0;
  }
`;

const StyledButton = styled.button`
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 8px;
  border-color: ${GreyStroke};
  background: #ffffff;
  color: ${Primary};
  width: 32px;
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${Focused};
    border-color: ${Focused};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }

  @media ${device.lcd} {
    font-size: 0.75rem;
    width: 24px;
    height: 24px;
  }
`;

export default function QuantityInput({ onChange, value = 1, ...props }) {
  return (
    <NumberInput
      aria-label="Quantity Input"
      onChange={(event, val) => onChange(val)}
      min={1}
      value={value}
      {...props}
    />
  );
}
